import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import ProductSection from '../../components/ProductSection/ProductSection';
import CTA from '../../components/CTA/CTA';
class Software extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="mobile" />
        <ServiceBanner product {...this.props} service page="mobile" />
        <ProductSection yellowBar noPadBottom {...this.props} page="mobile" section="benefits">
          <TextGroup  {...this.props} page="mobile" section="benefits" />
        </ProductSection>
        <ProductSection noTitle noPadTitle noImg yellowBar  {...this.props} page="mobile" >
          <CTA noBG {...this.props} />
        </ProductSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(Software);